import { VendorField } from '../../../Utilities/Enums/ParametersEnum';
import { ActiveStatusEnum } from '../../../Utilities/Enums/StatusEnums';

export class Vendor {
    [VendorField.PUBLIC_ID]?: string | number = "";
    [VendorField.CODE]?: string = "";
    [VendorField.NAME]?: string = "";
    [VendorField.STATUS]: ActiveStatusEnum = ActiveStatusEnum.ACTIVE;
    [VendorField.COMPANY_PUBLIC_IDS]?: any = [];
    [VendorField.COMPANIES]?: any = [];
    [VendorField.CREATED_DATE]?: string | Date | null = null;
    [VendorField.UPDATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<Vendor>) {
        Object.assign(this, obj);
    }
}

export class AddEditVendorModalInterface {
    openAddEditModal?: boolean;
    setopenAddEditModal?: React.Dispatch<React.SetStateAction<boolean>>;
    selectedVendor?: Vendor;
    setselectedVendor?: React.Dispatch<React.SetStateAction<Vendor>>;

    constructor(obj?: Partial<AddEditVendorModalInterface>) {
        Object.assign(this, obj);
    }
}